<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0"> Gestión de Roles y Permisos </p>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <h6>Seleccionar Rol a Editar:</h6>
              </div>
              <div class="col-md-4">
                <select
                  id="role-select"
                  v-model="selectedRoleId"
                  @change="handleRoleChange"
                  :disabled="state.loading"
                  class="flex-grow p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 bg-white shadow-inner"
                >
                  <option :value="null" disabled>--- Seleccione un Rol ---</option>
                  <option v-for="role in state.roles" :key="role.id" :value="role.id">
                    {{ role.name }} (ID: {{ role.id }})
                  </option>
                </select>
              </div>
              <div class="col-md-2 ">
                <argon-button
                  class="mt-0"
                  color="success"
                  fullWidth
                  @click="toCreate"
                  >Agregar Nuevo</argon-button>
              </div>
            </div>
          </div>
          <div class="card-footer">
          </div>
        </div>
      </div>
    </div>

    <div v-if="state.loading && !state.roles.length" class="flex justify-center items-center h-64 text-blue-600">
      <svg class="animate-spin h-6 w-6 mr-3 text-blue-600" viewBox="0 0 24 24"></svg>
      Cargando datos iniciales...
    </div>
    <div v-else-if="state.error && !state.roles.length" class="text-center p-4 bg-red-100 text-red-700 rounded-md shadow-md">
      <p class="font-bold">Error Fatal:</p>
      {{ state.error }}
    </div>

    <div v-else-if="state.currentRole" class="max-w-6xl mx-auto border border-gray-200 rounded-xl shadow-xl p-0 bg-white mt-4">

      <header class="p-6 border-b border-gray-100">
        <h3 class="text-2xl font-bold text-gray-800">
          Matriz de Permisos para:
          <span class="text-indigo-600">{{ state.currentRole.name }}</span>
        </h3>
      </header>

      <div class="max-h-[70vh] overflow-y-auto">

        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50 sticky top-0 z-10 shadow-sm">
            <tr>
              <th class="px-6 py-3 text-left text-sm font-bold text-gray-600 uppercase w-1/2">
                Módulo / Entidad
              </th>
              <th class="px-6 py-3 text-center text-sm font-bold text-gray-600 uppercase w-1/4">
                Ver (READ)
              </th>
              <th class="px-6 py-3 text-center text-sm font-bold text-gray-600 uppercase w-1/4">
                Escribir / Modificar
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-100">

            <template v-for="permissionGroup in groupedPermissions" :key="permissionGroup.moduleId">
              <tr class="bg-indigo-50/50">
                <td :colspan="3" class="px-6 py-2 font-extrabold text-indigo-700 text-base shadow-inner">
                  {{ permissionGroup.moduleName }}
                </td>
              </tr>

              <tr v-for="actionSet in permissionGroup.actions" :key="actionSet.baseCode" class="hover:bg-gray-50 transition duration-100">

                <td class="px-6 py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{ actionSet.name }}
                  <span class="block text-xs text-gray-400 font-normal mt-0.5">{{ actionSet.baseCode }}</span>
                </td>

                <td class="px-6 py-3 text-center">
                  <input
                    type="checkbox"
                    :value="actionSet.readId"
                    v-model="selectedPermissionIds"
                    :disabled="!actionSet.readId || state.loading"
                    class=""
                  />
                </td>

                <td class="px-6 py-3 text-center">
                  <input
                    type="checkbox"
                    :value="actionSet.writeId"
                    v-model="selectedPermissionIds"
                    :disabled="!actionSet.writeId || state.loading"
                    class="disabled:opacity-50"
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <footer class="p-6 border-t border-gray-100 flex justify-end">
        <argon-button
          class="mt-0"
          color="success"
          fullWidth
          @click="savePermissions"
          :disabled="state.loading"
        >
          <svg v-if="state.loading" class="animate-spin h-5 w-5 mr-3 inline-block" viewBox="0 0 24 24"></svg>
          {{ state.loading ? 'Aplicando cambios...' : 'Guardar y Aplicar Permisos' }}
        </argon-button>
        <div v-if="state.error && !state.loading" class="mt-3 text-sm text-red-600 font-medium absolute left-6 bottom-6">Error al guardar: {{ state.error }}</div>
      </footer>
    </div>

    <div v-else class="max-w-6xl mx-auto flex justify-center items-center h-96 border border-gray-200 rounded-xl col-span-5 text-gray-500 text-xl font-medium bg-white shadow-xl mt-4">
      Por favor, seleccione un rol en el menú desplegable para comenzar a editar permisos.
    </div>

    <div v-if="showCreateModal" class="fixed inset-0 bg-gray-600 bg-opacity-75 overflow-y-auto h-full w-full z-50 flex items-center justify-center">
        <div class="relative bg-white rounded-lg shadow-xl w-full max-w-md mx-auto p-6">
            <h3 class="text-xl font-bold mb-4">Crear Nuevo Rol</h3>

            <div class="mb-4">
                <label for="newRoleName" class="block text-sm font-medium text-gray-700">Nombre del Rol</label>
                <input
                    type="text"
                    id="newRoleName"
                    v-model="newRoleNameInput"
                    :disabled="state.loading"
                    class="form-control mt-1"
                >
            </div>

            <div class="flex justify-end space-x-2">
                <button
                    @click="showCreateModal = false"
                    type="button"
                    class="btn btn-secondary"
                    :disabled="state.loading"
                >
                    Cancelar
                </button>
                <button
                    @click="handleRoleCreation"
                    type="button"
                    class="btn btn-success"
                    :disabled="state.loading"
                >
                    {{ state.loading ? 'Creando...' : 'Crear Rol' }}
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars, require-atomic-updates */
import ArgonButton from "@/components/ArgonButton.vue";
import { ref, reactive, onMounted, computed, watch } from 'vue';
import RolesAPI from '@/api/roles';

// 🛑 ESTADO REACTIVO LOCAL 🛑
const state = reactive({
    roles: [],
    permissions: [],
    currentRole: null,
    loading: false,
    error: null,
});

const selectedRoleId = ref(null);
const selectedPermissionIds = ref([]);
// 🛑 NUEVO ESTADO PARA EL MODAL Y EL NOMBRE DEL ROL 🛑
const showCreateModal = ref(false);
const newRoleNameInput = ref('');


// ------------------------------------------------------------------
// 🛑 FUNCIONES DE LÓGICA DE DATOS Y EVENTOS 🛑
// ------------------------------------------------------------------

const fetchAllData = async () => {
    state.loading = true;
    state.error = null;
    try {
        const [rolesResponse, permissionsResponse] = await Promise.all([
            RolesAPI.getRoles(),
            RolesAPI.getPermissions(),
        ]);

        state.roles = rolesResponse.data;
        state.permissions = permissionsResponse.data;

        // Seleccionar el primer rol automáticamente
        if (state.roles.length > 0 && selectedRoleId.value === null) {
            selectedRoleId.value = state.roles[0].id;
            await fetchRoleDetails(selectedRoleId.value);
        }

    } catch (error) {
        state.error = 'Error al cargar datos de roles y permisos. Revise la conexión API.';
        console.error("Error en fetchAllData:", error);
    } finally {
        state.loading = false;
    }
};

const fetchRoleDetails = async (id) => {
    state.loading = true;
    state.error = null;
    try {
        const roleResponse = await RolesAPI.getRoleDetails(id);
        const assignedResponse = await RolesAPI.getAssignedPermissions(id);

        const assignedPermissionIds = assignedResponse.data.map(item => item.permission_id);

        state.currentRole = {
            ...roleResponse.data,
            assigned_permission_ids: assignedPermissionIds
        };
        // Sincronizar el estado de los checkboxes
        selectedPermissionIds.value = assignedPermissionIds;
    } catch (error) {
        state.error = 'Error al cargar detalles y permisos del rol.';
        console.error("Error en fetchRoleDetails:", error);
    } finally {
        state.loading = false;
    }
};

const updatePermissions = async (roleId, roleName, assignedPermissionIds) => {
    state.loading = true;
    state.error = null;
    let success = false;
    try {
        const payload = {
            name: roleName,
            assigned_permission_ids: assignedPermissionIds
        };

        await RolesAPI.updateRolePermissions(roleId, payload);

        await fetchRoleDetails(roleId);

        success = true;
    } catch (error) {
        state.error = 'Error al actualizar permisos.';
        console.error("Error en updatePermissions:", error);
        success = false;
    } finally {
        state.loading = false;
    }
    return success;
};

// 🛑 FUNCIÓN PARA ABRIR EL MODAL 🛑
const toCreate = () => {
    newRoleNameInput.value = ''; // Limpiamos el input
    showCreateModal.value = true;
};

// 🛑 FUNCIÓN REAL DE CREACIÓN DE ROL 🛑
const handleRoleCreation = async () => {
    const roleName = newRoleNameInput.value.trim();

    if (!roleName || roleName.length < 3) {
        alert("El nombre del rol es obligatorio y debe tener al menos 3 caracteres.");
        return;
    }

    state.loading = true;

    try {
        const payload = {
            name: roleName
        };

        // LLAMADA REAL A LA API: POST /roles
        const response = await RolesAPI.createRole(payload);

        alert(`Rol "${roleName}" creado exitosamente.`);

        showCreateModal.value = false;

        // 1. Refrescar la lista de roles completa
        await fetchAllData();

        // 2. Seleccionar el nuevo rol automáticamente
        const newlyCreatedRole = response.data; // Asumiendo que la respuesta tiene el objeto del nuevo rol

        if (newlyCreatedRole && newlyCreatedRole.id) {
            selectedRoleId.value = newlyCreatedRole.id;
            // fetchRoleDetails se llama automáticamente via watch o handleRoleChange si es necesario,
            // pero fetchAllData ya recargó el estado.
        }

    } catch (error) {
        console.error("Error al crear el rol:", error.response || error);
        state.error = `Error al crear el rol: ${error.response?.data?.error || 'Ocurrió un error al contactar con la API.'}`;
        alert(state.error);
    } finally {
        state.loading = false;
        newRoleNameInput.value = '';
    }
};


// ------------------------------------------------------------------
// 🛑 PROPIEDADES COMPUTADAS Y MANEJO DE VISTA 🛑
// ------------------------------------------------------------------

const getEntityName = (baseCode) => {
    const mapping = {
        'ROLES': 'Roles del Sistema', 'CLIENTS': 'Clientes', 'PRODUCTS': 'Productos / Artículos',
        'SUPPLIERS': 'Proveedores', 'INVOICE_HEADERS': 'Facturas (Cabecera)', 'INVENTORY_MOVEMENTS': 'Movimientos de Inventario',
        'PURCHASE_ORDERS': 'Órdenes de Compra', 'PERMISSIONS': 'Permisos (Maestro)', 'USER': 'Usuarios del Sistema',
        'ACTIVITIES': 'Actividades Comerciales', 'UNITS': 'Unidades de Medida', 'PRODUCTS_CATEGORY': 'Categorías de Productos',
        'COMPANY_CONFIG': 'Configuración de Empresa', 'LOCATIONS': 'Ubicaciones', 'WAREHOUSES': 'Almacenes',
        'INVENTORY_LOTS': 'Lotes de Inventario', 'INVOICE_LINES': 'Líneas de Factura', 'DRIVERS': 'Conductores',
        'VEHICLES': 'Vehículos', 'DELIVERY_ROUTES': 'Rutas de Entrega', 'ROUTE_STOPS': 'Paradas de Ruta',
        'AUDIT_LOGS': 'Logs de Auditoría', 'SERIAL': 'Seriales / Consecutivos'
    };
    return mapping[baseCode] || baseCode.replace(/_/g, ' ');
};

const groupedPermissions = computed(() => {
    const moduleGroups = state.permissions.reduce((acc, perm) => {
        const moduleId = perm.module_id || perm.category || 'OTROS';
        const moduleName = perm.category || `Módulo ID ${moduleId}`;

        if (!acc[moduleId]) {
            acc[moduleId] = { moduleId, moduleName, actions: {} };
        }

        const parts = perm.code.split('_');
        const actionType = parts.pop();
        const baseCode = parts.join('_');

        if (!acc[moduleId].actions[baseCode]) {
            acc[moduleId].actions[baseCode] = { baseCode, name: getEntityName(baseCode), readId: null, createEditId: null, deleteId: null };
        }

        if (actionType === 'READ' || actionType === 'VIEWER') {
            acc[moduleId].actions[baseCode].readId = perm.id;
        } else if (actionType === 'CREATE_EDIT' || actionType === 'CREATE') {
            acc[moduleId].actions[baseCode].createEditId = perm.id;
        } else if (actionType === 'DELETE') {
            acc[moduleId].actions[baseCode].deleteId = perm.id;
        }

        return acc;
    }, {});

    return Object.values(moduleGroups)
        .filter(group => Object.keys(group.actions).length > 0)
        .map(group => {
            group.actions = Object.values(group.actions)
                .map(action => {
                    const finalWriteId = action.createEditId || action.deleteId;
                    return {
                        baseCode: action.baseCode, name: action.name, readId: action.readId, writeId: finalWriteId
                    };
                })
                .filter(action => action.readId || action.writeId);
            return group;
        })
        .sort((a, b) => a.moduleName.localeCompare(b.moduleName));
});


const handleRoleChange = () => {
    if (selectedRoleId.value) {
        fetchRoleDetails(selectedRoleId.value);
    } else {
        state.currentRole = null;
        selectedPermissionIds.value = [];
    }
};


const savePermissions = async () => {
    if (!state.currentRole) return;

    const success = await updatePermissions(
        state.currentRole.id,
        state.currentRole.name,
        selectedPermissionIds.value
    );

    if (success) {
        alert('Permisos actualizados correctamente.');
    }
};


// Lógica de Sincronización
watch(() => state.currentRole, (newRole) => {
    if (newRole && newRole.assigned_permission_ids) {
        selectedPermissionIds.value = newRole.assigned_permission_ids;
    } else {
        selectedPermissionIds.value = [];
    }
}, { deep: true });


// Montaje: Cargar datos iniciales
onMounted(() => {
    fetchAllData();
});
</script>